import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import EventCard from './EventCard'
import {
  EMPTY_ARRAY,
  EMPTY_OBJECT,
  EVENT_TYPES,
} from '../../constants/globalConstants'
// import { convertParkingTime } from '../../utils/helper'
import { Row } from 'react-bootstrap'
// import CommonBtn from './CommonBtn'
import { globalKeyStore } from '../../redux/actions/globalState'
import { useNavigate } from 'react-router'
import URL from '../../constants/urls'
import PrevArrow from './Arrows/PrevArrow'
import NextArrow from './Arrows/NextArrow'
import { useParams } from 'react-router-dom'
// import CONSTANTS from '../../redux/constants'
import moment from 'moment'
import NoImage from './NoImage'
import PassBooking from '../../pages/booking/PassBooking'
import { getPriceBreakdown } from '../../utils/helper'
// import { getSessionDetails } from '../../redux/actions/booking'
// import CONSTANTS from '../../redux/constants'
// import getConfigDetails  from '../../services/config'

function MultipleEventCrousel({
  passData,
  isMainScreen,
  dispatch,
  typeDetails,
  passId,
  selectEventType,
  sessionDetails,
  displayQr,
  hidePaymentDetails,
  paymentResponse,
  eventViewStyle,
  singlepassDetails,
  notify,
  page,
  selectedFacilityId,
  independantPass,
  // independant_pass_id,
}) {
  const slider = React.useRef(null)
  const [passSold, setPassSold] = useState(null)
  const [locPassData, setLocPassData] = useState(null)
  const [chooseEvents, setchooseEvents] = useState(EMPTY_ARRAY)
  const [bookPass, setBookPass] = useState(false)
  const passDetails = JSON.parse(localStorage.getItem('passDetails'))
  const { partner, facility } = useParams()
  const passRef = useRef(null)
  let currentFilpass = singlepassDetails?.filter((item) => {
    return item.id == passId
  })
  const [currentpass, setCurrentPass] = useState(EMPTY_OBJECT)
  useEffect(() => {
    if (isMainScreen) {
      localStorage.removeItem('userChooseEvents')
    }

    // if(Object.values(passData)?.length < 1){
    if (!passData) {
      const passdata = JSON.parse(localStorage.getItem('passData'))
      dispatch(
        globalKeyStore({
          selectedPassId: Number(passdata?.id),
          passData: passdata,
        })
      )
      if (passdata?.id) {
        let passArr =
          passDetails?.length > 0
            ? passDetails?.filter((item) => {
                return passdata.id == item.pass_id
              })
            : []
        setPassSold(passArr.length > 0 ? passArr[0].is_pass_sold : null)
      } else {
        setPassSold(null)
      }
    } else {
      if (passData?.id) {
        let passArr =
          passDetails?.length > 0
            ? passDetails?.filter((item) => {
                return passData.id == item.pass_id
              })
            : []
        setPassSold(passArr.length > 0 ? passArr[0].is_pass_sold : null)
      } else {
        setPassSold(null)
      }

      if (page == 'details' && passData?.is_full_season == 0) {
        let userSel = JSON.parse(localStorage.getItem('userChooseEvents'))
        if (userSel?.length > 0) {
          let pass = passData?.all_event?.filter((item) => {
            let cur = false
            userSel.map((ev) => {
              if (item.id == ev) {
                cur = true
              }
            })
            return cur
          })
          setchooseEvents(userSel)
          setLocPassData(pass)
        }
      }
    }
    setCurrentPass(currentFilpass[0])
  }, [passData])

  useEffect(() => {
    if (bookPass) {
      executeScroll()
      setBookPass(false)
    }
  }, [bookPass])

  const executeScroll = () =>
    passRef.current.scrollIntoView({ behavior: 'auto' })

  const user = partner

  const navigate = useNavigate()

  const handleBookingButtton = (passData = null) => {
    // if (passData?.all_event?.length > 0) {
      dispatch(globalKeyStore({ selectedPassId: passData?.id }))
      localStorage?.setItem('booking_event', passData?.id)

      if (user) {
        // navigate(`${user}/${URL?.BOOKING_PAGE}/${passData?.id}`) // Old functionality
        if (independantPass || passData?.id) {
            console.log('1', user, facility)
          navigate(`/${user?.replace(/\//g, '')}/${selectedFacilityId}${passData?.id ? '/' + passData?.id : ''}/bookingdetail`)
        } else if (facility && facility != '') {
            console.log('1', user, facility)

          navigate(
            `/${user?.replace(/\//g, '')}/${facility}${passData?.id ? '/' + passData?.id : ''}/bookingdetail`
          )
        } else {
          if (
            currentpass.is_full_season == '0' &&
            currentpass.pass_type_status != '1'
          ) {
            const userChooseEvents = JSON.parse(
              localStorage.getItem('userChooseEvents')
            )
            if (userChooseEvents && userChooseEvents.length > 0) {
            console.log('1', user, facility)

              navigate(`/${user?.replace(/\//g, '')}/${URL?.BOOKING_DETAIL}`)
            } else {
              notify('error', 'Please select event to proceeded.')
            }
          } else {
            console.log('1', user, facility)

            navigate(`/${user?.replace(/\//g, '')}${passData?.facility_id ? '/' + passData?.facility_id : '/'}${passData?.id ? '/' + passData?.id : ''}/bookingdetail`)
          }
        }
      } else {
        navigate('*')
      }
    // } else if (passData?.pass_type_slug === 'simple-pass') {
    //   const sessionPayload = {
    //     is_first_load: 1,
    //     facility_id: selectedFacilityId,
    //     rate_id: '',
    //     event_id: '',
    //     client_id: getConfigDetails?.CLIENT_SECRET,
    //   }
    //   if (passData?.id || independant_pass_id) {
    //     sessionPayload.rate_id = independant_pass_id
    //       ? Number(independant_pass_id)
    //       : passData?.id
    //       ? Number(passData?.id)
    //       : ''
    //   }
    //   dispatch(getSessionDetails(sessionPayload))
    //     .then((res) => {
    //       dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
    //       dispatch(globalKeyStore({ sessionDetails: res }))
    //     })
    //     .catch(() => {
    //       dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
    //     })
    //   setBookPass(true)
    // }
  }

  // important setting for the crousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'ease-out',
    responsive: [{ breakpoint: 600, settings: { arrows: false } }],
    nextArrow: <NextArrow onClick={() => slider?.current?.slickNext()} />,
    prevArrow: <PrevArrow onClick={() => slider?.current?.slickPrev()} />,
  }

  const handleCheckBoxEvent = (e) => {
    const SelectedEvents = JSON.parse(JSON.stringify(chooseEvents)) //Array in parent component
    const value = e.target.value //Checkbox value
    var index = SelectedEvents?.indexOf(e.target.value)
    SelectedEvents?.includes(value) //If Array contains value
      ? SelectedEvents?.indexOf(value) !== -1 && !e.target.checked
        ? SelectedEvents?.splice(index, 1)
        : ''
      : SelectedEvents?.push(value) // Else, push item to Array
    if (
      currentpass?.pass_type_slug == EVENT_TYPES?.BUNDLE_PASS &&
      currentpass?.is_full_season == 0
    ) {
      if (SelectedEvents?.length <= Number(currentpass?.total_usage)) {
        // notify()
        setchooseEvents(SelectedEvents)
        localStorage.setItem(
          'userChooseEvents',
          JSON.stringify(SelectedEvents)
        )
      } else {
        notify(
          'error',
          'You can select only ' + currentpass?.total_usage + ' Events'
        )
      }
    }
  }

  return isMainScreen ? (
    <div>
      {/* <br />
            <br />
            {JSON.stringify(currentpass?.pass_type_slug)}
            {JSON.stringify(EVENT_TYPES?.BUNDLE_PASS)}
            {JSON.stringify(currentpass?.is_full_season)}
            {JSON.stringify(currentpass?.pass_type_slug == EVENT_TYPES?.BUNDLE_PASS && currentpass?.is_full_season == 0)}
            <br />
            <br /> */}

      {currentpass?.pass_type_slug == EVENT_TYPES?.BUNDLE_PASS ? (
        <div className={`${!page ? 'mt-4' : ''} border border-primary rounded indiPass border-3`}>
            <div className='d-flex justify-content-between p-2 passHeader text-white'>
            <span className='h3 fw-bold m-0 text-start w-100 '>
                {passData?.description}
            </span>
            <div className='col-auto'>
                <span>
                    {(passData?.all_event?.length > 0 ||
                        passData?.pass_type_slug === 'simple-pass') && (
                          <>
                            <span className='fw-bold m-0 text-white pe-2'>
                              {passData?.price ? (
                                <>${Number(passData?.price)?.toFixed(2)}</>
                              ) : (
                                '0.00'
                              )}
                            </span>
                            {!bookPass &&
                            new Date(
                              moment(new Date(passData?.end_date)).format(
                                'MM/DD/YYYY'
                              )
                            ) >=
                              new Date(
                                moment(new Date()).format('MM/DD/YYYY')
                              ) ? (
                              <button
                                value='Book Now'
                                onClick={() => handleBookingButtton(passData)}
                                className={
                                  'btn btn-danger text-uppercase px-4'
                                }
                              >
                                Book Now
                              </button>
                            ) : null}
                          </>
                        )}
                </span>
            </div>

            </div>
            <div className='justify-content-center '>
                <div className='col-sm-12 col-12'>
                    <div className='p-3 topContainer shadow shadow-lg '>
                        <div className='row align-items-center'>
                            <div className='col-sm-6 h-full d-flex justify-content-center border-end border-1 border-primary'>
                                {passData?.image_url ? (
                                <img
                                    className='img-fluid rounded'
                                    src={passData?.image_url}
                                    style={{ maxHeight: '180px' }}
                                />
                                ) : (
                                <div
                                    className='d-flex justify-content-center align-items-center h-100'
                                    style={{ minHeight: '100px' }}
                                >
                                    <NoImage />
                                </div>
                                )}
                            </div>
                            <div className='col-sm-6 col-12'>
                                <div className='d-flex h-100 flex-column justify-content-center'>
                                    <div>
                                        {/* <h2 className='m-0 fw-bold text-primary'>
                                        {passData?.description}
                                        </h2> */}
                                        {passData?.pass_type_slug !== 'simple-pass' &&
                                        passData?.pass_type_slug !== 'party-pass' &&
                                        passData?.pass_type_slug !== 'bundle-pass' && (
                                            <p className='fw-bold m-2 h5 fw-bold mt-2'>
                                                <span className='text-primary'><i className='fa fa-map-marker'></i>{' '}
                                                {passData?.facility?.full_name}</span>
                                            </p>
                                        )}
                                        {passData?.details ? (
                                        <p className='m-2 h5 fw-bold'>
                                        <span className='text-primary'><i className='fa fa-circle-info'></i>{' '}
                                        {passData?.details}</span>
                                        </p>
                                        ) : (
                                        ''
                                        )}
                                        {passData?.days_open_description ? (
                                        <p className='m-2 h5 fw-bold d-none'>
                                        <span className='text-primary'><i className='fa fa-calendar-day'></i>{' '}
                                        {passData?.days_open_description}</span>
                                        </p>
                                        ) : (
                                        ''
                                        )}
                                        {passData?.end_date && passData?.start_date ? (
                                            <p className='m-2 h5 fw-bold'>
                                                <span className='text-primary'><i className='fa fa-calendar-days'></i> Valid{' '}
                                                {moment(passData?.start_date).format('MMM Do YYYY')}{' '}
                                                - {moment(passData?.end_date).format('MMM Do YYYY')}</span>
                                            </p>
                                        ) : (
                                        ''
                                        )}
                                        {passData?.total_usage ? (
                                            <p className='m-2 h5 fw-bold'>
                                                <span className='text-primary'><i className='fa-solid fa-ticket text-primary'></i> Total Usage -{' '}
                                                {passData?.total_usage}</span>
                                            </p>
                                        ) : (
                                        ''
                                        )}
                                    </div>
                                <div>
                                    {/* <div className=' m-0 '><i className='fa fa-calendar '></i> {moment(passData?.start_date).format('dddd Do MMM, YYYY')}</div> */}
                                </div>
                                </div>
                            </div>
                            {passData?.all_event?.length > 0 && (
                                <div className='col-12 align-self-center  text-sm-end col-sm'>
                                <h1 className='fw-bold  text-primary'>
                                    {passData?.all_event?.length > 0 ? (
                                    <>${Number(passData?.price)?.toFixed(2)}</>
                                    ) : (
                                    ''
                                    )}
                                </h1>
                                <button
                                    disabled={
                                    passSold && Number(passSold) === 1
                                        ? true
                                        : passData?.all_event?.length > 0
                                        ? false
                                        : true
                                    }
                                    value={
                                    passSold && Number(passSold) === 1
                                        ? 'Sold Out'
                                        : 'Book Now'
                                    }
                                    onClick={() => handleBookingButtton(passData)}
                                    className={
                                    passSold && Number(passSold) === 1
                                        ? 'btn btn-lg text-uppercase px-4 btn-outline-danger fw-bold'
                                        : 'btn btn-primary btn-lg text-uppercase px-4'
                                    }
                                >
                                    {passSold && Number(passSold) === 1
                                    ? 'Sold Out'
                                    : 'Book Now'}
                                </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className='p-3 border-top bottom-container'>
                {passData?.all_event?.length > 0 ? (
                <ul className='d-flex flx-column nav gap-4'>
                    {passData?.all_event?.map((item, index) => (
                    <li
                        className='d-flex w-100 flex-column border eventList flex-md-row '
                        key={'passData_' + index}
                    >
                        <div className='blocks round-start d-flex d-sm-block gap-3 p-3 bg-white'>
                        <div
                            className=' overflow-hidden rounded-3 d-flex justify-content-between align-items-center'
                            style={{ width: '100px', height: '100px' }}
                        >
                            {item?.image_url ? (
                            <img className='img-fluid' src={item?.image_url} />
                            ) : (
                            <NoImage className='rounded-3' />
                            )}
                        </div>
                        <div className='d-block d-sm-none flex-grow-1'>
                            <div>
                            <h2 className='m-0 fw-bold text-primary '>
                                {item?.title}
                            </h2>
                            <div className='m-0 small'>
                                *Event parking starts at 8:14 AM &amp ends at 8:14
                                PM
                            </div>
                            </div>

                            <div className=' m-0 '>
                            <i className='fa fa-calendar '></i>{' '}
                            {moment(item?.start_time).format('dddd Do MMM, YYYY')}{' '}
                            </div>

                            <div className=' m-0 '>
                            <i className='fa fa-clock '></i>{' '}
                            {moment(item?.end_time).format('hh:mm A')} Kickoff
                            Time{' '}
                            </div>
                        </div>
                        {currentpass?.is_full_season == 0 ? (
                            <div className='d-block d-sm-none form-check'>
                            <input
                                value={item.id}
                                disabled={
                                passSold && Number(passSold) === 1 ? true : false
                                }
                                style={{ width: '20px', height: '20px' }}
                                className='form-check-input'
                                type='checkbox'
                                checked={chooseEvents.includes(
                                JSON.stringify(item?.id)
                                )}
                                onChange={handleCheckBoxEvent}
                            />
                            </div>
                        ) : (
                            ''
                        )}
                        </div>
                        <div className='blocks d-none d-sm-flex flex-column flex-sm-row  w-100 justify-content-between align-items-center border-sm-bottom  p-3 bg-white border-sm-top '>
                        <div style={{ width: '300px' }}>
                            <h2 className='m-0 fw-bold text-primary '>
                            {item?.title}
                            </h2>
                            <div className='m-0 small'>{`*Event parking starts at  ${moment(
                            item?.parking_start_time
                            ).format('MM/DD/YYYY hh:mm A')} & ends at  ${moment(
                            item?.parking_end_time
                            ).format('MM/DD/YYYY hh:mm A')}`}</div>
                        </div>

                        <div className=' m-0 '>
                            <i className='fa fa-calendar '></i>{' '}
                            {moment(item?.start_time).format('dddd Do MMM, YYYY')}{' '}
                        </div>

                        <div className=' m-0 '>
                            <i className='fa fa-clock '></i>{' '}
                            {moment(item?.end_time).format('hh:mm A')} Kickoff Time{' '}
                        </div>
                        {currentpass?.is_full_season == 0 ? (
                            <div className='d-none d-sm-block form-check'>
                            <input
                                value={item.id}
                                className='form-check-input'
                                style={{ width: '20px', height: '20px' }}
                                disabled={
                                passSold && Number(passSold) === 1 ? true : false
                                }
                                type='checkbox'
                                checked={chooseEvents.includes(
                                JSON.stringify(item?.id)
                                )}
                                onChange={handleCheckBoxEvent}
                            />
                            </div>
                        ) : (
                            ''
                        )}
                        </div>
                        <div className=' d-flex round-end p-1 p-sm-auto  flex-sm-column align-items-center justify-content-sm-center justify-content-between px-4  border border-warning  bg-warning bg-opacity-10'>
                        <span>Started at</span>
                        <h4 className='text-nowrap fw-bold text-dark m-0'>
                            {moment(item?.start_time).format('hh:mm A')}
                        </h4>
                        </div>
                    </li>
                    ))}
                </ul>
                ) : (
                <h4 className='w-100 text-primary py-3 text-center'>
                    No events available.
                </h4>
                )}
            </div>
        </div>
      ) : (
        <div className='border border-primary rounded indiPass border-3'>
          <div className='d-flex justify-content-between p-2 passHeader text-white'>
            <span className='h3 fw-bold m-0 text-start w-100 '>
                {passData?.description}
            </span>
            <div className='col-auto'>
                <span>
                    {(passData?.all_event?.length > 0 ||
                        passData?.pass_type_slug === 'simple-pass') && (
                          <>
                            <span className='fw-bold m-0 text-white pe-2'>
                              {passData?.price ? (
                                <>${Number(passData?.price)?.toFixed(2)}</>
                              ) : (
                                '0.00'
                              )}
                            </span>
                            {!bookPass &&
                            new Date(
                              moment(new Date(passData?.end_date)).format(
                                'MM/DD/YYYY'
                              )
                            ) >=
                              new Date(
                                moment(new Date()).format('MM/DD/YYYY')
                              ) ? (
                              <button
                                value='Book Now'
                                onClick={() => handleBookingButtton(passData)}
                                className={
                                  'btn btn-danger text-uppercase px-4'
                                }
                              >
                                Book Now
                              </button>
                            ) : null}
                          </>
                        )}
                </span>
            </div>

          </div>

          <div className='justify-content-center '>
            <div className='col-sm-12 col-12'>
              <div className='p-3 topContainer shadow shadow-lg'>
                <div className='row '>
                  <div className='col-sm-6 h-full d-flex justify-content-center p-2 border-end border-1 border-primary'>
                    {passData?.image_url ? (
                      <img
                        className='img-fluid rounded'
                        src={passData?.image_url}
                        style={{ maxHeight: '180px', width: 'auto' }}
                      />
                    ) : (
                      <div
                        className='d-flex justify-content-center align-items-center h-100'
                        style={{ minHeight: '100px' }}
                      >
                        <NoImage />
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-12'>
                    <div className='d-flex p-4 h-100 flex-column justify-content-center'>
                      <div>
                        {/* <h2 className='m-0 fw-bold mb-2 text-primary'>
                          {passData?.description}
                        </h2> */}
                        {passData?.pass_type_slug !== 'simple-pass' &&
                          passData?.pass_type_slug !== 'party-pass' &&
                          passData?.pass_type_slug !== 'bundle-pass' && (
                            <p className='fw-bold m-2 h5 fw-bold mt-2'>
                                <span className='text-primary'><i className='fa fa-map-marker'></i>{' '}
                             {passData?.facility?.full_name}</span>
                            </p>
                          )}
                        {passData?.details ? (
                          <p className='m-2 h5 fw-bold'>
                            <span className='text-primary'><i className='fa fa-circle-info'></i>{' '}
                            {passData?.details}</span>
                          </p>
                        ) : (
                          ''
                        )}
                        {passData?.days_open_description ? (
                          <p className='m-2 h5 fw-bold d-none'>
                            <span className='text-primary'><i className='fa fa-calendar-day'></i>{' '}
                            {passData?.days_open_description}</span>
                          </p>
                        ) : (
                          ''
                        )}
                        {passData?.end_date && passData?.start_date ? (
                          <p className='m-2 h5 fw-bold'>
                            <span className='text-primary'><i className='fa fa-calendar-days'></i> Valid{' '}
                            {moment(passData?.start_date).format('MMM Do YYYY')}{' '}
                            - {moment(passData?.end_date).format('MMM Do YYYY')}</span>
                          </p>
                        ) : (
                          ''
                        )}
                        {passData?.total_usage ? (
                          <p className='m-2 h5 fw-bold'>
                            <span className='text-primary'><i className='fa-solid fa-ticket text-primary'></i> Total Usage -{' '}
                            {passData?.total_usage}</span>
                          </p>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className='d-none d-flex mt-2 justify-content-between align-items-center'>
                        {/* <div className=' m-0 '><i className='fa fa-calendar '></i> {moment(passData?.start_date).format('dddd Do MMM, YYYY')}</div> */}
                        {(passData?.all_event?.length > 0 ||
                          passData?.pass_type_slug === 'simple-pass') && (
                          <>
                            <h4 className='fw-bold font-sm m-0  text-primary'>
                              {passData?.price ? (
                                <>${Number(passData?.price)?.toFixed(2)}</>
                              ) : (
                                '0.00'
                              )}
                            </h4>
                            {!bookPass &&
                            new Date(
                              moment(new Date(passData?.end_date)).format(
                                'MM/DD/YYYY'
                              )
                            ) >=
                              new Date(
                                moment(new Date()).format('MM/DD/YYYY')
                              ) ? (
                              <button
                                value='Book Now'
                                onClick={() => handleBookingButtton(passData)}
                                className={
                                  'btn btn-primary text-uppercase px-4'
                                }
                              >
                                Book Now
                              </button>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Row className='py-3 g-0 mt-2'>
                    <Col><h3 className='text-primary fw-bold'>{passData?.description}</h3></Col>
                    {(passData?.all_event?.length > 0) && <Col className='col-auto d-flex align-items-center'>{(passData?.all_event?.length > 0) ? <span className='fw-bold text-primary pe-4 h4 text-center mt-2'>${Number(passData?.price)?.toFixed(2)}</span> : ''}<CommonBtn type='button' disabled={(passSold && Number(passSold) === 1) ? true : (passData?.all_event?.length > 0) ? false : true} className={(passSold && Number(passSold) === 1) ? 'btn btn-lg btn-outline-danger fw-bold' : 'btn btn-primary'} value={(passSold && Number(passSold) === 1) ? 'Sold Out' : 'Book'} onClick={handleBookingButtton} /></Col>}
                </Row> */}
          <Row
            className={
              eventViewStyle == 'list'
                ? `row row-cols-1 g-4 mt-0 col-cols-sm-2 ${(passData?.pass_type_slug && passData?.pass_type_slug == 'simple-pass') ? '' : 'eventScroll'}`
                : 'row row-cols-2 g-4 mt-0 col-cols-sm-2'
            }
          >
            {passData?.all_event?.length > 0 ? (
              // <Slider {...settings} className='mb-3'>
              passData?.all_event?.map((item, index) =>
                item?.id ? (
                  <EventCard
                    key={item?.id}
                    qrCodeValue={paymentResponse?.mapco_qrcode?.[index]?.qrcode}
                    imageUrl={item?.image_url ? item?.image_url : 'NoImage'}
                    title={item?.title}
                    detials={item?.description}
                    startDate={item?.start_time}
                    time={item}
                    // time={convertParkingTime(
                    //   item?.parking_start_time,
                    //   item?.parking_end_time
                    // )}
                    // paybaleAmount={item?.paybaleAmount ? item?.paybaleAmount : ''}
                    id={item?.id}
                    parkingPrice={
                      selectEventType == 'event'
                        ? item?.event_rate
                        : item?.price
                        ? item?.price
                        : 0
                    }
                    tax_rate={
                      item?.tax_rate ? Number(item?.tax_rate)?.toFixed(2) : 0
                    }
                    amount={item?.amount ? Number(item?.amount)?.toFixed(2) : 0}
                    displayQr={displayQr}
                    hidePaymentDetails={hidePaymentDetails}
                    paymentResponse={paymentResponse}
                    isCrousalEvent
                    facilitiesName={passData?.facility?.full_name}
                    typeDetails={typeDetails}
                    passId={passId}
                    isMultiplefacility={
                      item?.event_facility && item?.event_facility?.length > 1
                    }
                    className='m-0'
                    isPass
                  />
                ) : (
                  ''
                )
              )
            ) : (
              // </Slider>
              <>
                <h4
                  className={`${
                    passData?.pass_type_slug === 'simple-pass' ? 'd-none ' : ''
                  }w-100 text-primary py-3 text-center`}
                >
                  No events available.
                </h4>
                <div
                  ref={passRef}
                  id='pass-booking'
                  className={`${
                    bookPass && passData?.pass_type_slug === 'simple-pass'
                      ? 'd-block'
                      : 'd-none'
                  }`}
                >
                  {independantPass ? (
                    <div className='row justify-content-center align-items-center'>
                      <div className='col-sm-8'>
                        {' '}
                        <PassBooking
                          dispatch={dispatch}
                          passData={passData}
                          bookPass={bookPass}
                          notify={notify}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                    <PassBooking
                      dispatch={dispatch}
                      passData={passData}
                      bookPass={bookPass}
                      notify={notify}
                    /></>
                  )}
                </div>
              </>
            )}
          </Row>
        </div>
      )}
      {/* {typeDetails == CONSTANTS.YEAR_PASS ? <>
            <div className='border'>
                <div className='p-3 topContainer shadow shadow-lg '>
                    <div className='row'>
                        <div className='col-sm-3 col'>
                            <img className='img-fluid rounded' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfFn2wX0vsBd2wlW6DzdwrCwE5vXINyGWUPQ&s'/>
                        </div>
                        <div className='col-sm-auto col-12'>
                            <div className='d-flex h-100 flex-column justify-content-between '>

                          
                            <div>
                                <h2 className='m-0 fw-bold text-primary'>Event_Test_9</h2>
                                <p className='fw-bold m-0'><i className='fa fa-map-marker'></i> Portland Campus-Garage 1</p>
                            </div>
                            <div>
                            <div className=' m-0 '><i className='fa fa-calendar '></i> Monday 8th Jul, 2024 </div>
                            <div className='m-0 small'>*Event parking starts at  $8:14 AM &amp ends at  $8:14 PM</div>
                            </div>
                           
                            </div>
                        </div>
                        <div className='col-12 align-self-end  text-sm-end col-sm'>
                        <h1 className='fw-bold  text-primary'>$100.00</h1>
                        <button className='btn  btn-primary btn-lg text-uppercase px-4' >Book Parking</button>
                        </div>
                    </div>
                </div>
                <div className='p-3 border-top bottom-container'>
                    <ul className='d-flex flx-column nav gap-4'>
                    { Array(5).fill(<li className='d-flex w-100 flex-column border eventList flex-sm-row ' >
                        
                            <div className='blocks round-start d-flex d-sm-block gap-3 p-3 bg-white  '>
                                <img style={{maxWidth:'60px',borderRadius:'10px'}}  className='img-fluid ' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeogT82KVDAPp1q4S3rjbJ6stvLu_zrPry8w&s'/>
                                <div className='d-block d-sm-none' >
                                <h2 className='m-0 fw-bold text-primary '>Often Moca Match</h2>
                           
                            
                           <div className=' m-0 '><i className='fa fa-calendar '></i> Monday 8th Jul, 2024 </div>
                           
                          
                           <div className=' m-0 '><i className='fa fa-clock '></i> 7PM Kickoff Time </div>
                                </div>
                            </div>
                            <div className='blocks d-none d-sm-flex flex-column flex-sm-row  w-100 justify-content-between align-items-sm-center border-sm-bottom  p-3 bg-white border-sm-top '>
                                <h2 className='m-0 fw-bold text-primary '>Often Moca Match</h2>
                           
                            
                            <div className=' m-0 '><i className='fa fa-calendar '></i> Monday 8th Jul, 2024 </div>
                            
                           
                            <div className=' m-0 '><i className='fa fa-clock '></i> 7PM Kickoff Time </div>
                            </div>
                            <div className=' d-flex round-end p-1 p-sm-auto  flex-sm-column align-items-center justify-content-sm-center justify-content-between px-4  border border-warning  bg-warning bg-opacity-10'>
                               <span>Started at</span>
                               <h4 className='text-nowrap fw-bold text-dark m-0' >08:00 PM</h4>
                            </div>
                            
                        </li>) }

                      
                        
                        
                    </ul>
                </div>
            </div>
          </> : ''} */}
    </div>
  ) : (
    <div className='border border-primary rounded border-2'>
      <div className='row' id='event Details section'>
        <div className='col'>
          <h3 className='passHeader fw-bold text-white p-2'>
            <small className='text-white fw-bold'>
              <span className='text-white'>Pass:</span>{' '}
              {passData?.description}
            </small>
          </h3>
        </div>
      </div>
      <div className='multi_events'>
        <Slider {...settings}>
          {page == 'success'
            ? paymentResponse?.event_type == 'party-pass'
              ? paymentResponse?.mapco_qrcode?.[0]?.event_category?.event_category_event?.map(
                  (item, index) => {
                    if (paymentResponse?.mapco_qrcode?.[0]?.qrcode) {
                      return (
                        <EventCard
                          key={index}
                          qrCodeValue={
                            paymentResponse?.mapco_qrcode?.[0]?.qrcode
                          }
                          imageUrl={
                            item?.event?.image_url ? item?.image_url : 'NoImage'
                          }
                          title={item?.event?.title}
                          detials={item?.event?.description}
                          startDate={item?.event?.start_time}
                          isPass
                          // time={convertParkingTime(
                          //   item?.event?.parking_start_time,
                          //   item?.event?.parking_end_time
                          // )}
                          time={item}
                          // paybaleAmount={item?.event?.paybaleAmount}
                          id={item?.event?.id}
                          parkingPrice={
                            selectEventType == 'event'
                              ? item?.event?.event_rate
                              : item?.event?.price
                          }
                          displayQr={displayQr}
                          hidePaymentDetails={hidePaymentDetails}
                          paymentResponse={paymentResponse}
                          isCrousalEvent
                          facilitiesName={passData?.facility?.full_name}
                          passId={passId}
                          isMultiplefacility={
                            item?.event_facility &&
                            item?.event_facility?.length > 1
                          }
                        />
                      )
                    } else {
                      return ''
                    }
                  }
                )
              : passData?.all_event?.map((item, index) => {
                  if (paymentResponse?.mapco_qrcode?.[index]?.qrcode) {
                    return (
                      <EventCard
                        key={index}
                        qrCodeValue={
                          paymentResponse?.mapco_qrcode?.[index]?.qrcode
                        }
                        imageUrl={item?.image_url ? item?.image_url : 'NoImage'}
                        title={item?.title}
                        detials={item?.description}
                        startDate={item?.start_time}
                        // time={convertParkingTime(
                        //   item?.parking_start_time,
                        //   item?.parking_end_time
                        // )}
                        time={item}
                        // paybaleAmount={item?.paybaleAmount}
                        id={item?.id}
                        parkingPrice={
                          selectEventType == 'event'
                            ? item?.event_rate
                            : item?.price
                        }
                        displayQr={displayQr}
                        hidePaymentDetails={hidePaymentDetails}
                        paymentResponse={paymentResponse}
                        isCrousalEvent
                        facilitiesName={passData?.facility?.full_name}
                        passId={passId}
                        isMultiplefacility={
                          item?.event_facility &&
                          item?.event_facility?.length > 1
                        }
                        isPass
                      />
                    )
                  } else {
                    return ''
                  }
                })
            : page == 'details' && locPassData?.length > 0
            ? locPassData?.map((item, index) => (
                <EventCard
                  key={item?.id}
                  qrCodeValue={paymentResponse?.mapco_qrcode?.[index]?.qrcode}
                  imageUrl={item?.image_url ? item?.image_url : 'NoImage'}
                  title={item?.title}
                  detials={item?.description}
                  startDate={item?.start_time}
                  // time={convertParkingTime(
                  //   item?.parking_start_time,
                  //   item?.parking_end_time
                  // )}
                  time={item}
                  // paybaleAmount={item?.paybaleAmount ? item?.paybaleAmount : ''}
                  id={item?.id}
                  parkingPrice={
                    selectEventType == 'event'
                      ? item?.event_rate
                      : item?.price
                      ? item?.price
                      : 0
                  }
                  tax_rate={
                    item?.tax_rate ? Number(item?.tax_rate)?.toFixed(2) : 0
                  }
                  amount={item?.amount ? Number(item?.amount)?.toFixed(2) : 0}
                  displayQr={displayQr}
                  hidePaymentDetails={hidePaymentDetails}
                  paymentResponse={paymentResponse}
                  isCrousalEvent
                  facilitiesName={passData?.facility?.full_name}
                  typeDetails={typeDetails}
                  isMultiplefacility={
                    item?.event_facility && item?.event_facility?.length > 1
                  }
                  isPass
                />
              ))
            : passData?.all_event?.map((item, index) => (
                <EventCard
                  key={item?.id}
                  qrCodeValue={paymentResponse?.mapco_qrcode?.[index]?.qrcode}
                  imageUrl={item?.image_url ? item?.image_url : 'NoImage'}
                  title={item?.title}
                  detials={item?.description}
                  startDate={item?.start_time}
                  // time={convertParkingTime(
                  //   item?.parking_start_time,
                  //   item?.parking_end_time
                  // )}
                  time={item}
                  // paybaleAmount={item?.paybaleAmount ? item?.paybaleAmount : ''}
                  id={item?.id}
                  parkingPrice={
                    selectEventType == 'event'
                      ? item?.event_rate
                      : item?.price
                      ? item?.price
                      : 0
                  }
                  tax_rate={
                    item?.tax_rate ? Number(item?.tax_rate)?.toFixed(2) : 0
                  }
                  amount={item?.amount ? Number(item?.amount)?.toFixed(2) : 0}
                  displayQr={displayQr}
                  hidePaymentDetails={hidePaymentDetails}
                  paymentResponse={paymentResponse}
                  isCrousalEvent
                  facilitiesName={passData?.facility?.full_name}
                  typeDetails={typeDetails}
                  isMultiplefacility={
                    item?.event_facility && item?.event_facility?.length > 1
                  }
                  isPass
                />
              ))}
        </Slider>
      </div>
      <div className='bill-card mt-3 p-2'>
        <div className='row align-items-center'>
          <div className='fw-bold text-primary col text-start'>
            Parking Price{/* Including Tax*/}
          </div>
          <div className='col text-end fw-bold text-primary'>${passData?.price}</div>
        </div>
        {getPriceBreakdown(sessionDetails)}
      </div>
      <div className='d-flex p-2 bg-primary bg-opacity-10 border justify-content-between'>
        <h3 className='fw-bold text-primary p-0 m-0'>Total Price -</h3>
        <h3 className='fw-bold text-primary p-0 m-0'>
          $
          {sessionDetails?.data?.amount
            ? Number(sessionDetails?.data?.amount)?.toFixed(2)
            : '0.00'}
        </h3>
      </div>
    </div>
  )
}

MultipleEventCrousel.propTypes = {
  dispatch: PropTypes.func,
  notify: PropTypes.func,
  passData: PropTypes.object,
  isMainScreen: PropTypes.bool,
  selectEventType: PropTypes.string,
  sessionDetails: PropTypes.object,
  displayQr: PropTypes.bool,
  hidePaymentDetails: PropTypes.bool,
  paymentResponse: PropTypes.object,
  eventViewStyle: PropTypes.string,
  typeDetails: PropTypes.string,
  passId: PropTypes.string,
  page: PropTypes.string,
  selectedFacilityId: PropTypes.string,
  independantPass: PropTypes.bool,
  singlepassDetails: PropTypes.array,
  independant_pass_id: PropTypes.string,
}

MultipleEventCrousel.defaulProps = {
  dispatch: noop,
  notify: noop,
  passData: EMPTY_OBJECT,
  isMainScreen: false,
  selectEventType: '',
  sessionDetails: EMPTY_OBJECT,
  displayQr: false,
  hidePaymentDetails: false,
  paymentResponse: EMPTY_OBJECT,
  eventViewStyle: '',
  typeDetails: '',
  passId: '',
  page: '',
  selectedFacilityId: '',
  singlepassDetails: EMPTY_ARRAY,
  independantPass: false,
  independant_pass_id: '',
}

function mapStateToProps({ globalReducers, mainReducer }) {
  return {
    passData: globalReducers?.passData,
    selectEventType: globalReducers?.selectEventType,
    sessionDetails: globalReducers?.sessionDetails,
    singlepassDetails: mainReducer?.passDetails,
    selectedFacilityId: globalReducers?.selectedFacilityId,
  }
}

export default connect(mapStateToProps)(MultipleEventCrousel)
